module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Door-open-40d3d62e1a548a2dc1968a699c504f2a.svg";